import { LitElement, html } from 'lit';
import { customElement } from 'lit/decorators.js';

@customElement('product-colors')
class ProductColors extends LitElement {
  constructor() {
    super();
    this.colorButtons = this.querySelectorAll('[data-swatch-button]');
    this.colorButtons.forEach((button) => {
      button.addEventListener('click', this.handleColorButtonClick);
    });
    this.selectedClasses = ['ring-1', 'ring-offset-4', 'ring-black'];
  }

  handleColorButtonClick = (e) => {
    const { productId, productHandle } = e.target.dataset;
    const swatchChangeEvent = new CustomEvent('swatch:change', {
      detail: {
        product: {
          id: productId,
          handle: productHandle,
        },
      },
    });

    this.colorButtons.forEach((btn) => {
      const button = btn;
      button.classList.remove(...this.selectedClasses);
      button.dataset.isSelected = 'false';
    });
    e.target.classList.add(...this.selectedClasses);
    e.target.dataset.isSelected = 'true';

    window.dispatchEvent(swatchChangeEvent);
  };

  render() {
    return html` <slot></slot>`;
  }
}

export default ProductColors;
